<template>
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <ol class="breadcrumbs-list">
      <li v-for="(item, i) in items" :key="i" class="breadcrumbs-item">
        <router-link v-if="item.to && i < items.length - 1" :to="item.to">
{{ item.label }}
</router-link>
        <span v-else aria-current="page">{{ item.label }}</span>
        <span v-if="i < items.length - 1" class="sep" aria-hidden="true"> &gt; </span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    /** @type {{ label: string, to?: string }[]} */
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  // max-width: 900px;
  width: 100%;
  margin: 0 auto 1.25rem;
  font-size: 0.9rem;
  color: #555;
  ol {
    margin-left: 0 !important;
  }
}
.breadcrumbs-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.breadcrumbs-item {
  display: inline-flex;
  align-items: center;
}
.breadcrumbs a {
  color: #128c7e;
  text-decoration: none;
}
.breadcrumbs a:hover {
  text-decoration: underline;
}
.sep {
  margin: 0 0.35rem;
  color: #999;
}
</style>
